var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle125(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 59,
    viewBox: "0 0 46 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6952 6.73904L38.7042 6.749L38.7138 6.75853L44.1799 12.2247C44.923 12.9678 45.3405 13.9756 45.3405 15.0264V54.4717C45.3405 56.66 43.5665 58.434 41.3782 58.434H5.15161C2.96331 58.434 1.18933 56.66 1.18933 54.4717V4.66016C1.18933 2.47185 2.9633 0.697876 5.15161 0.697876H31.4504C32.5668 0.697876 33.6313 1.1688 34.3823 1.99484L38.6952 6.73904Z",
    fill: "#1E5369",
    fillOpacity: 0.1,
    stroke: "#115264",
    strokeWidth: 1.13208
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle125);
export default __webpack_public_path__ + "static/media/Rectangle 125.8c959e748d6040f51e2e4ff833996dc1.svg";
export { ForwardRef as ReactComponent };